import { Controller } from "remult";

@Controller("call-center-org-settings-methods")
export class CallCenterOrgSettingsMethods {}
